import { writable } from 'svelte/store';
const beatInfo = writable(null);
export default beatInfo;
export { beatInfo, };
